"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlatformId = void 0;
var react_1 = require("react");
var application_context_1 = require("../components/context/application-context");
// TODO, define supported options
var usePlatformId = function () {
  var _a;
  var application = (0, react_1.useContext)(application_context_1.ApplicationContext);
  return ((_a = application === null || application === void 0 ? void 0 : application.metadata) === null || _a === void 0 ? void 0 : _a.id) || '';
};
exports.usePlatformId = usePlatformId;